import {CartItem} from './cart-item.model';
import {CartItemType} from './cart-item-type.model';

export class ReservationCartItem extends CartItem {
  reservationId: string;
  hotelId: string;
  roomCode: string;
  rateCode: string;
  freeNightId: string;
  pointsAndCashId: string;
  numAdults: number;
  numChildren: number;
  corpId: string;
  groupCode: string;
  iataNumber: string;
  numRooms: number;
  checkinDate: Date;
  checkoutDate: Date;
  selectedCurrency: string;

  constructor() {
    super();
    this.itemType = CartItemType.RESERVATION;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/common/model/shopping-cart/reservation-item.model.ts